var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('ion-app',{attrs:{"id":"page"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }